export const APP_NAME = 'movilidad-notifications';
